export interface LocalizedLanguage {
  id?: string;
  languageCode: LanguageCode;
  value: string;
}

export type LanguageCode = 'en-US' | 'de-DE' | 'it-IT' | 'fr-FR';

export enum LanguageCodes {
  en = 'en-US',
  de = 'de-DE',
  it = 'it-IT',
  fr = 'fr-FR',
}

export const languageCodeValues = Object.values(LanguageCodes);

export type LocalizedLanguageFormData = Record<LanguageCode, string>;

export const toLocalizedLanguages = (
  formData: LocalizedLanguageFormData
): LocalizedLanguage[] =>
  Object.entries(formData).map(([code, value]) => ({
    languageCode: code as LanguageCode,
    value,
  }));

export const languageMap: LocalizedLanguageFormData = {
  'en-US': 'common.language.en-US',
  'de-DE': 'common.language.de-DE',
  'it-IT': 'common.language.it-IT',
  'fr-FR': 'common.language.fr-FR',
};
